<button [id]="componentId + '-btn'" [attr.data-cy]="componentId + '-btn'" (click)="emitClick($event)"
  class="text-white bg-red-100 w-full rounded px-9 py-2 hover:bg-red text-sm" [disabled]="disableBtn"
  [ngClass]="{'text-white-900 !bg-white-disabled' : disableBtn}">
  {{btnText}} <ng-content></ng-content>
</button>
